function MintedCard({ image, ic }) {
    return (
        <div className="w-[346px] h-full relative">
            <img className="w-[346px] h-full rounded-lg " src={image} alt="claimed-card" />
            {ic?.blockchain?.image && (
                <img
                    className="absolute w-5 h-5 rounded-full bottom-[.625rem] right-[.625rem]"
                    src={ic?.blockchain?.image}
                    alt={ic?.blockchain?.name}
                />
            )}
        </div>
    );
}

export default MintedCard;
